
import { defineComponent, ref, onBeforeUnmount } from 'vue';
import LoaderSpm from '@/assets/lottie/Loader.json';
// eslint-disable-next-line import/extensions
import '@/assets/js/lottie-player.js';

export default defineComponent({
  name: 'Loader',

  setup() {
    const loaderLottieRef = ref();

    onBeforeUnmount(() => {
      if (loaderLottieRef.value) {
        loaderLottieRef.value.destroy();
      }
    });

    return {
      LoaderSpm,
      loaderLottieRef,
    };
  },

});
